window.addEventListener('load', ()=> {
    baguetteBox.run('.gallery');
})